module.exports = __webpack_public_path__ + "img/bn24.f4b3ba95.png";